var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQrBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 8.5V26c0 .414-.168.79-.44 1.06-.27.272-.646.44-1.06.44H4c-.414 0-.79-.168-1.06-.44A1.495 1.495 0 0 1 2.5 26V8.5h27z",
    stroke: "#595959",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 16.5c.414 0 .79.168 1.06.44.272.27.44.646.44 1.06v9.5h-17V18c0-.414.168-.79.44-1.06.27-.272.646-.44 1.06-.44z",
    stroke: "#595959",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.008 3.274 5.484 4.483a3.625 3.625 0 0 1-.942 2.705 3.178 3.178 0 0 1-2.336 1.038c-.495 0-.966-.117-1.388-.327-.688.818-1.685 1.327-2.79 1.327a3.61 3.61 0 0 1-2.513-1.03 4.387 4.387 0 0 1-1.19 1.278A4.007 4.007 0 0 1 16 13.5a4.008 4.008 0 0 1-2.333-.752 4.393 4.393 0 0 1-1.19-1.278 3.608 3.608 0 0 1-2.513 1.03c-1.104 0-2.101-.51-2.79-1.327-.422.21-.893.327-1.388.327a3.178 3.178 0 0 1-2.336-1.038 3.624 3.624 0 0 1-.943-2.7l5.287-4.488h16.214z",
    stroke: "#595959",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 12,
    y: 22,
    width: 3,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    transform: "rotate(90 16 22)",
    x: 10.5,
    y: 21.5,
    width: 11,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#595959",
    x: 17,
    y: 22,
    width: 3,
    height: 1,
    rx: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQrBusiness);
export default __webpack_public_path__ + "static/media/icon-qr-business.0278cdf3970ecd90f94cbdbbba4230ac.svg";
export { ForwardRef as ReactComponent };